import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PresentationIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Presentation",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M4.9 4.7h22.44c.69-.07 1.23-.64 1.23-1.35S28.03 2.07 27.35 2H4.77c-.75 0-1.35.61-1.35 1.35S4.03 4.7 4.77 4.7zm21.38 2.93H5.96c-.82 0-1.49.67-1.49 1.49v13.21c0 .84.67 1.5 1.49 1.5h7.87l-3.91 3.91a1.322 1.322 0 1 0 1.87 1.87l4.8-4.81 4.81 4.81c.24.23.56.38.92.38h.01c.36 0 .69-.14.94-.38.24-.24.39-.57.39-.94s-.15-.7-.39-.94l-3.91-3.91h6.88c.83 0 1.5-.67 1.5-1.5V9.12c0-.81-.65-1.48-1.45-1.5Zm-1.15 13.56H7.11V10.27h18.04v10.92Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M25.86 19H5.29c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43h20.57c1.89 0 3.43 1.54 3.43 3.43v10.28c0 1.89-1.54 3.43-3.43 3.43M5.29 4.14c-.63 0-1.14.51-1.14 1.14v10.28c0 .63.51 1.14 1.14 1.14h20.57c.63 0 1.14-.51 1.14-1.14V5.29c0-.63-.51-1.14-1.14-1.14H5.29Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M25.86 29.29c-.29 0-.58-.11-.81-.33l-9.48-9.48-9.48 9.48c-.45.45-1.17.45-1.62 0a1.14 1.14 0 0 1 0-1.62l10.29-10.29a1.14 1.14 0 0 1 1.62 0l10.29 10.29a1.14 1.14 0 0 1-.81 1.95M16.71 8.71h-2.29a1.14 1.14 0 1 1 0-2.28h2.29a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};